<ion-header class="ion-no-border">
  <ion-toolbar color="primary">

    <ion-title>Crea un nuovo gruppo teleconsulto</ion-title>

    <ion-buttons slot="end"> 

      <ion-button (click)="closeModal()">
        <ion-icon slot="icon-only" [src]="'close' | getIcon"></ion-icon>
      </ion-button>

    </ion-buttons>

  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <ion-grid>
    <ion-row>
      <ion-col>
        <p>
          Crea un nuovo gruppo per il teleconsulto. Seleziona i medici da inserire nel gruppo.
        </p>
      </ion-col>
    </ion-row>
  <ion-row>
    <ion-col  size="12">
      <ion-item>
        <ion-label position="stacked">Seleziona i partecipanti</ion-label>
      </ion-item>
          <ion-list>
            <ion-row *ngIf="loading">
              <ion-col class="c3-flex ion-justify-content-center">
                <ion-spinner color="secondary"></ion-spinner>
              </ion-col>
            </ion-row>
            <ion-list-header *ngIf="participantsList.size === 0">
              <ion-label>Nessun risultato</ion-label>
            </ion-list-header>
              <ion-item *ngFor="let partec of participantsList">
                  <ion-label>{{partec.surname}}  {{partec.name}}</ion-label>
                  <ion-checkbox (ionChange)="updateParticipants($event,partec)"></ion-checkbox>
              </ion-item>
          </ion-list>
  </ion-col>
  
  </ion-row>
  <ion-row>
    <ion-col size="12">
        <ion-item>
            <ion-label position="floating">Inserisci nome Team:</ion-label>
            <ion-input placeholder="Enter text" [(ngModel)]="name" (ionChange)="checkSelection()"></ion-input>
          </ion-item>
          <br>
          <ion-label style="color:red;" *ngIf="creationValue"><small>Devi inserire almeno 1 partecipante ma massimo 5 e il nome del team</small></ion-label>
    </ion-col>
  </ion-row>

</ion-grid>
</ion-content>
<ion-footer class="ion-padding">
  <ion-row>
    <ion-col size="12" style="text-align:right;">
      <ion-button color="primary" (click)="closeModal()">Annulla</ion-button>
      <ion-button color="primary" [disabled]="creationValue" (click)="creaTeam()">Salva</ion-button>
    </ion-col>
  </ion-row>
</ion-footer>